import React from 'react';
import { Button, Checkbox, Form } from 'antd';
import {
  loginIsLogin,
  loginModalOpen,
  loginLegalIssuesModalOpen,
} from 'app/actions/Login/login.action';
import { setStateUserEnter } from 'app/actions/Users/user.enter.action';
import { userConstants } from 'app/constants/user.constants';
import { FormattedMessage } from 'react-intl';
import AbstractMachine from './abstractMachine';

import userAPI from '../../../../API/user.service.api';
import { REGISTER } from '../../../../constants/enter.user.constants';
import { SelectTourNewsForm } from '../../../Utility/TourNews/selectTourNewsForm';
import SelectCountryForm from '../../../Utility/selectCountry/selectCountryForm';
import AliaslUserInput from '../../../Utility/CustomeInputForm/AliasInputForm';
import CheckLegalIssues from '../../../Utility/CheckLeggalIssues/legalIssues';
import { openNotificationWithIcon } from '../../../Utility/notificationMessage';
import { updateAuthenticationUserData } from '../../../../actions/Users/users.action';
import { fixHttps } from '../../../Utility/coreFunctions';

export default class Register extends AbstractMachine {
  constructor(form, goTo) {
    super(form, goTo);

    this._name = REGISTER;
    this.languageTournews = 'en';
  }

  getTitle = () => {
    return <FormattedMessage id="Register" defaultMessage="Register" />;
  };

  moveLegalWindowTop = (dispatch) => {
    dispatch(loginLegalIssuesModalOpen(true));
  };

  onLegalIssuesChange = () => {
    this._goTo(null, this.moveLegalWindowTop);
  };

  handleChange = (value) => {
    if (value && value.length === 2) this.languageTournews = value;
    else console.info(value);
  };

  submitSocial = (props) => {
    const { login, facebook_id, google_id, imageUrl } = props;
    this._form
      .validateFields()
      .then((values) => {
        const params = this.prepareParams({
          ...values,
          login,
          facebook_id,
          google_id,
          imageUrl,
        });
        this._goTo(null, this.registerSocial, params);
      })
      .catch((err) => console.info(err));
  };

  updateUserAvatar = (dispatch, userdata, imageUrl) => {
    userAPI.updateAvararFromURL(imageUrl).then((data) => {
      if (data.code === 200) {
        const { path } = data.response;
        if (path)
          dispatch(
            updateAuthenticationUserData({
              ...userdata,
              avatar: fixHttps(path),
            })
          );
      }
    });
  };

  registerSocial = (dispatch, params) => {
    userAPI
      .register(params)
      .then((data) => {
        if (data && data.code !== 200) {
          const state = {
            name: this._name,
            error: data.message,
          };
          dispatch(setStateUserEnter(state));
        } else {
          const { userdata } = data.response;
          dispatch(this.success(userdata));
          dispatch(loginIsLogin(true));

          dispatch(loginModalOpen(false));
          dispatch(setStateUserEnter({ name: 'start' }));

          if (params.imageUrl)
            this.updateUserAvatar(dispatch, userdata, params.imageUrl);
        }
      })
      .catch((err) => openNotificationWithIcon('error', err.message));
  };

  prepareParams = (values) => {
    if (values.country) values.country = values.country.split('_').pop();
    values.languageTournews = this.languageTournews;
    values.isRemember = +values.remember;
    delete values.remember;
    values.legalIssues = +values.legalIssues;
    values.subscribeTournews = +values.subscribeTournews;
    if (!values.login) values.login = values.userEmail;

    return values;
  };

  success = (user) => ({ type: userConstants.LOGIN_SUCCESS, user });

  isSocialButtonsAllowed = () => {
    return false;
  };

  render(props) {
    const { userEmail } = props;
    return (
      <div className="newUser">
        {this.getMainInput({ ...props, disabled: !!userEmail })}

        <AliaslUserInput form={this._form} />
        <SelectCountryForm form={this._form} loc={props.loc} />
        <CheckLegalIssues
          form={this._form}
          clickHandler={this.onLegalIssuesChange}
        />
        <SelectTourNewsForm
          form={this._form}
          handleChange={this.handleChange}
        />

        <Form.Item
          style={{ marginTop: '-11px', width: '100%', marginBottom: '0px' }}
          name="remember"
          valuePropName="checked"
          initialValue
        >
          <Checkbox style={{ fontSize: '12px' }}>
            <FormattedMessage id="Remember me" defaultMessage="Remember me" />
          </Checkbox>

          <Button
            type="primary"
            style={{ marginTop: '11px' }}
            className="ant-btn-primary width100"
            onClick={() => this.submitSocial({ ...props })}
          >
            <span>
              <FormattedMessage id="Register" defaultMessage="Register" />
            </span>
          </Button>
        </Form.Item>
      </div>
    );
  }
}
